import axios from 'axios';
import md5 from 'crypto-js/md5';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var AB_WIND_TRACK = {
  event: 'abtest_track',
  event_id: 125,
  ab_tags: [] // ${experimentId}_${data.versionId}

};

var WIND_TRACK = function WIND_TRACK(option, abTags) {
  var user_id = option.user_id,
      device_id = option.device_id,
      is_login = option.is_login,
      app_name = option.app_name;
  var timestamp = new Date().getTime();
  var versions = '8.12.0';
  var env = 'prod';
  var project = app_name;

  if (app_name.endsWith('_dev')) {
    env = 'dev';
    project = app_name.replace('_dev', '');
  }

  if (process) {
    versions = process.versions && process.versions.node || '8.12.0';
  }

  return {
    data: {
      attributes: {
        ab_tags: abTags // ['vasjrjj']

      },
      device_id: String(device_id),
      user_id: String(user_id),
      is_login: Number(is_login),
      event: AB_WIND_TRACK.event,
      event_id: AB_WIND_TRACK.event_id,
      timestamp: timestamp,
      env: env
    },
    project: project,
    sdk_version: '1.0.0',
    report_time: timestamp,
    path: '/wind',
    runtime: {
      plat: 'node',
      // 平台
      version: "v".concat(versions) // 版本

    }
  };
};

var gzip = function gzip(input, options) {
  var zlib = require('zlib');

  var promise = new Promise(function (resolve, reject) {
    zlib.gzip(input, options, function (error, result) {
      if (!error) resolve(result);else reject(Error(error));
    });
  });
  return promise;
};

var abtestTrack = function abtestTrack(option, abTags) {
  return gzip(JSON.stringify(WIND_TRACK(option, abTags))).then(function (buffer) {
    var base64 = buffer.toString('base64');
    return axios.get("https://wind.hlgdata.com/wind?gzip=1&data=".concat(encodeURIComponent(base64)));
  }).catch(function (err) {
    console.log(err);
  });
};

function getGlobal() {
  if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else if (typeof global !== 'undefined') {
    return global;
  } else {
    // eslint-disable-next-line
    return Function("return this")();
  }
}

function getGlobalPolyfill() {
  if ((typeof global === "undefined" ? "undefined" : _typeof(global)) !== 'object' || !global || global.Math !== Math || global.Array !== Array) {
    return getGlobal();
  }

  return global;
}

var ABTEST_KEY_SIGN = 'ABTEST_KEY_SIGN'; // 前后端约定的key
// const API = 'http://172.16.2.5:12228/v2/strategy';
// const API = 'https://abtest-proxy.hlgdata.com/v2/strategy';

var rules = {
  app_key: [{
    require: true,
    message: 'parameter app_key is not present'
  }, {
    empty: false,
    message: 'parameter app_key cannot be empty'
  }],
  app_name: [{
    require: true,
    message: 'parameter app_name is not present'
  }, {
    empty: false,
    message: 'parameter app_name cannot be empty'
  }],
  user_id: [{
    require: true,
    message: 'parameter user_id is not present'
  }, {
    empty: true,
    message: 'parameter user_id cannot be empty'
  }],
  device_id: [{
    require: true,
    message: 'parameter device_id is not present'
  }, {
    empty: false,
    message: 'parameter device_id cannot be empty'
  }],
  is_login: [{
    require: false,
    message: 'parameter is_login is not present'
  }, // 允许 is_login 为空不传，该字段为保留字段暂时无用
  // {empty: false, message: 'parameter is_login cannot be empty'}
  {
    empty: true,
    message: 'parameter is_login cannot be empty'
  }],
  org_id: [{
    require: false,
    message: ''
  }, // 租户 id 非必填
  {
    empty: true,
    message: 'parameter org_id cannot be empty' // 允许为空字符串

  }]
};

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var GdABTestSdk =
/*#__PURE__*/
function () {
  function GdABTestSdk() {
    _classCallCheck(this, GdABTestSdk);

    this.option = null;
    this.hooks = {};
    this._requestInstance = null;
  }
  /**
   * 初始化
   * @param {Object} option
   * eg
   * gdABTestSdk.init({
   *   app_key: 'xxxxx', //应用对应的 appKey，必填
   *   app_name: 'xxxxx', // 应用对应的 appName，必填
   *   user_id:  'xxxxx', // 客户端能唯一标识用户的ID，必填
   *   device_id: 'xxxxx', // 设备ID，必填
   *   is_login: 'xxxx', // 是否登录，非必填
   *   org_id: 'xxxx' // 租户 id 非必填
   * })
   */


  _createClass(GdABTestSdk, [{
    key: "init",
    value: function init(option) {
      var flag = this._optionValidator(option);

      if (flag) {
        this.option = option; // this.getExps();
      }
    }
    /**
     * 根据 eventId 获取 abtags  同步
     * @param {array} eventId
     */

  }, {
    key: "getSyncAbTags",
    value: function getSyncAbTags(eventId) {
      // 获取本地策略
      return this.takeAbtags(eventId);
    }
    /**
     * 根据 eventId 获取 abtags  异步
     * @param {array} eventId
     */

  }, {
    key: "getAsyncAbTags",
    value: function getAsyncAbTags(eventId) {
      var _this = this;

      return new Promise(function (resolve) {
        // 获取本地策略
        var abtags = _this.takeAbtags(eventId);

        if (!abtags) {
          // 没有策略的话监听网络请求
          _this.on('fetch', function () {
            var abtags = _this.takeAbtags(eventId);

            resolve(abtags);
          }); // 超时或者没触发策略请求的话强行返回


          setTimeout(function () {
            var abtags = _this.takeAbtags(eventId);

            resolve(abtags);
          }, 2000);
          return;
        }

        resolve(abtags);
      });
    }
    /**
     * 根据 eventId 获取 abtags
     * @param {array} eventId
     */

  }, {
    key: "getAbTags",
    value: function getAbTags(eventId) {
      var _this2 = this;

      return new Promise(function (resolve) {
        // 获取本地策略
        var abtags = _this2.takeAbtags(eventId);

        if (!abtags) {
          // 没有策略的话监听网络请求
          _this2.on('fetch', function () {
            var abtags = _this2.takeAbtags(eventId);

            resolve(abtags);
          }); // 超时或者没触发策略请求的话强行返回


          setTimeout(function () {
            var abtags = _this2.takeAbtags(eventId);

            resolve(abtags);
          }, 2000);
          return;
        }

        resolve(abtags);
      });
    }
    /**
     * 获取本地策略
     * @param {*} eventId
     */

  }, {
    key: "takeAbtags",
    value: function takeAbtags(eventId) {
      var matchedExps = this._getMatchedExps(false);

      if (!matchedExps) {
        return null;
      }

      var exps = matchedExps.filter(function (exp) {
        return exp.eventIds.includes(eventId);
      });
      var abtags = exps.map(function (exp) {
        return "".concat(exp.experimentId, "_").concat(exp.versionId);
      });

      if (abtags.length === 0) {
        return null;
      }

      return abtags;
    }
    /**
     * 根据变量名称获取所匹配的版本信息的变量值
     * @param {string} variableName 变量名
     * @param {any} defaultVaule 无匹配值时返回默认值，默认 ‘’
     */

  }, {
    key: "getValue",
    value: function getValue(variableName, defaultVaule) {
      if (typeof variableName === 'string') {
        return this._getSingleValue(variableName, defaultVaule);
      }

      if (Array.isArray(variableName)) {
        if (!Array.isArray(defaultVaule)) {
          return 'defaultVaule should be an array';
        }

        return this._getMultipleValue(variableName, defaultVaule);
      }
    }
    /**
     * 根据变量名称获取所匹配的实验标识
     * @param {string} variableName 变量名
     * @returns 'abtag' | null
     */

  }, {
    key: "getTag",
    value: function getTag(variableName) {
      return this._getSingleTag(variableName);
    }
    /**
     * 设置 userId
     * @param {string|int} userId 用户id
     */

  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (!_this3.option) {
          reject(new Error('Please initialize sdk first'));
        } else {
          resolve();
        }
      }).then(function () {
        if (userId !== _this3.option.user_id) {
          _this3.option.user_id = userId;

          _this3._clearMatchedExps();

          return _this3.getExps();
        }
      }).catch(function (err) {
        console.error(err);
      });
    }
    /**
     * 设置 deviceId
     * @param {string|int} deviceId 设备 id
     */

  }, {
    key: "setDeviceId",
    value: function setDeviceId(deviceId) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (!_this4.option) {
          reject(new Error('Please initialize sdk first'));
        } else {
          resolve();
        }
      }).then(function () {
        if (deviceId !== _this4.option.device_id) {
          _this4.option.device_id = deviceId;

          _this4._clearMatchedExps();

          return _this4.getExps();
        }
      }).catch(function (err) {
        console.error(err);
      });
    }
    /**
     * 设置 orgId
     * @param {string|int} orgId 租户id
     */

  }, {
    key: "setOrgId",
    value: function setOrgId(orgId) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        if (!_this5.option) {
          reject(new Error('Please initialize sdk first'));
        } else {
          resolve();
        }
      }).then(function () {
        if (orgId !== _this5.option.org_id) {
          _this5.option.org_id = orgId;

          _this5._clearMatchedExps();

          return _this5.getExps();
        }
      }).catch(function (err) {
        console.error(err);
      });
    }
    /**
     * 注册监听事件 (返回一个用于取消监听的函数)
     * eg
     * const cancel = window.gdABTest.on('fetch', (reault) =>{
     *   console.log('--fetch---', reault);
     * })
     * @param {string} name
     * @param {function} callback
     * @returns {function} cancel
     */

  }, {
    key: "on",
    value: function on(name, callback) {
      if (!this.hooks[name]) {
        this.hooks[name] = [];
      }

      this.hooks[name].push(callback);
      var cancel = this.off.bind(this, name, callback);
      return cancel;
    }
    /**
     * 取消注册的监听事件
     * eg
     * const callback = (reault) => {
     *  console.log('--fetch---', reault);
     * };
     * // 1. 注册监听事件
     * window.gdABTest.on('fetch', callback)
     * // 2. 取消监听事件
     * window.gdABTest.off('fetch', callback)
     * @param {string} name
     * @param {function} callback
     */

  }, {
    key: "off",
    value: function off(name, callback) {
      if (!Array.isArray(this.hooks[name])) return;
      var newHooks = this.hooks[name].filter(function (fn) {
        return fn !== callback;
      });
      this.hooks[name] = newHooks;
    }
    /**
     * 运行 fetch事件
     * @param {array} data
     */

  }, {
    key: "runFetchHook",
    value: function runFetchHook(data) {
      if (!this.hooks.fetch) {
        return;
      }

      this.hooks.fetch.forEach(function (callback) {
        callback(data || []);
      });
    }
    /**
     * 运行 埋点事件
     * @param {object} data
     */

  }, {
    key: "runWindTrackHook",
    value: function runWindTrackHook(exps) {
      var ab_tags = exps.filter(function (data) {
        return data;
      }).map(function (data) {
        return "".concat(data.experimentId, "_").concat(data.versionId);
      });

      if (!this.hooks.windTrack) {
        if (!isBrowser()) {
          abtestTrack(this.option, ab_tags);
        }

        return;
      }

      this.hooks.windTrack.forEach(function (callback) {
        AB_WIND_TRACK.ab_tags = ab_tags || [];
        callback(AB_WIND_TRACK || {});
      });
    }
    /**
     * 获取所有匹配的版本信息
     * @param {function} callback 回调函数
     */

  }, {
    key: "getExps",
    value: function getExps() {
      var _this6 = this;

      return new Promise(function (resolve) {
        var exps = _this6._getMatchedExps();

        resolve(exps);
      }).then(function (exps) {
        if (exps) {
          return exps;
        } else {
          if (_this6._requestInstance) return _this6._requestInstance;
          _this6._requestInstance = _this6._requestExps();
          return _this6._requestInstance;
        }
      }).then(function (res) {
        return res;
      });
    }
    /**
     * 获取缓存策略
     */

  }, {
    key: "getCache",
    value: function getCache() {
      return this._getMatchedExps();
    }
  }, {
    key: "_getMatchedExps",
    value: function _getMatchedExps() {
      var timeOutFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var _ref = this.option || {},
          app_key = _ref.app_key,
          device_id = _ref.device_id;

      var _global = getGlobalPolyfill();

      if (_global.localStorage && _global.localStorage.getItem(app_key)) {
        var storage = JSON.parse(_global.localStorage.getItem(app_key));
        var exp = storage.data[0];

        if (exp && exp.deviceId !== device_id) {
          return null;
        }

        if (timeOutFlag && new Date().getTime() - storage.timestamp < 60 * 30 * 1000) {
          // 30 分钟
          return storage.data;
        }

        if (!timeOutFlag) {
          return storage.data;
        }
      }

      return null;
    }
  }, {
    key: "_setMatchedExps",
    value: function _setMatchedExps(data) {
      var _ref2 = this.option || {},
          app_key = _ref2.app_key;

      var _global = getGlobalPolyfill();

      if (_global.localStorage) {
        _global.localStorage.setItem(app_key, JSON.stringify({
          timestamp: new Date().getTime(),
          data: data
        }));
      }
    }
  }, {
    key: "_clearMatchedExps",
    value: function _clearMatchedExps() {
      var _ref3 = this.option || {},
          app_key = _ref3.app_key;

      var _global = getGlobalPolyfill();

      if (_global.localStorage) {
        _global.localStorage.removeItem(app_key);
      }
    }
    /**
     * 获取单个变量名对应的变量值
     * @param {string} variableName 变量名
     * @param {string} defaultVaule 默认值
     */

  }, {
    key: "_getSingleValue",
    value: function _getSingleValue(variableName) {
      var _this7 = this;

      var defaultVaule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return this.getExps().then(function (data) {
        var exp = data.filter(function (item) {
          return item.variableName === variableName;
        });

        if (exp[0] && exp[0].variableValue) {
          _this7.runWindTrackHook(exp);

          return exp[0].variableValue;
        }

        return defaultVaule;
      }).catch(function () {
        return defaultVaule;
      });
    }
    /**
     * 获取实验标识
     * @param {string} variableName 变量名
     */

  }, {
    key: "_getSingleTag",
    value: function _getSingleTag(variableName) {
      return this.getExps().then(function (data) {
        var exp = data.find(function (item) {
          return item.variableName === variableName;
        });

        if (exp) {
          return "".concat(exp.experimentId, "_").concat(exp.versionId);
        }

        return null;
      }).catch(function () {
        return null;
      });
    }
    /**
     * 获取多个变量名对应的变量值
     * @param {array} variableName 变量名
     * @param {array} defaultVaule 默认值
     */

  }, {
    key: "_getMultipleValue",
    value: function _getMultipleValue(variableNames) {
      var _this8 = this;

      var defaultVaule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return this.getExps().then(function (data) {
        var exps = variableNames.map(function (val) {
          return data.find(function (item) {
            return val === item.variableName;
          });
        });

        _this8.runWindTrackHook(exps);

        var vals = exps.map(function (exp, index) {
          if (exp) {
            return exp.variableValue;
          }

          return defaultVaule[index] || '';
        });
        return vals;
      }).catch(function () {
        return defaultVaule;
      });
    }
    /**
     * 私有方法，请求版本信息
     * @return Promise|null
     */

  }, {
    key: "_requestExps",
    value: function _requestExps() {
      var _this9 = this;

      // 私有化不上报
      // typeof window !== 'undefined' && window._IS_PRIVATE_
      // if(window && window._IS_PRIVATE_) {
      if (typeof window !== 'undefined' && window._IS_PRIVATE_) {
        return [];
      }

      if (!this.option) {
        console.error('please initialize sdk first');
        return;
      }

      var _this$option = this.option,
          app_key = _this$option.app_key,
          app_name = _this$option.app_name,
          user_id = _this$option.user_id,
          device_id = _this$option.device_id,
          is_login = _this$option.is_login,
          org_id = _this$option.org_id;
      var sign = md5(app_key + device_id + ABTEST_KEY_SIGN).toString().toUpperCase();
      return axios.get("https://abtest-proxy.hlgdata.com/v2/strategy/".concat(app_name), {
        params: {
          user_id: user_id,
          device_id: device_id,
          is_login: is_login,
          org_id: org_id
        },
        headers: {
          'ABTEST-SIGN': sign
        }
      }).then(function (res) {
        // this.runFetchHook(res.data);
        _this9._setMatchedExps(res.data);

        _this9.runFetchHook(res.data); // 一分钟内的请求复用之前的


        var timer = setTimeout(function () {
          _this9._requestInstance = null;
          clearTimeout(timer);
        }, 1000 * 60);
        return res.data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "_optionValidator",
    value: function _optionValidator(option) {
      for (var key in rules) {
        if (rules[key][0].require && option[key] === undefined) {
          console.error(rules[key][0].message);
          return false;
        }

        if (!rules[key][1].empty && !option[key]) {
          console.error(rules[key][1].message);
          return false;
        }
      }

      return true;
    }
  }]);

  return GdABTestSdk;
}();

var index = new GdABTestSdk();

export default index;
